import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randCity, randNumber } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MirageServer, MockServer } from './server.js'
import { filterable } from './utils.js'

type StockLocation = SchemaAttributes<'StockLocation'>

export const model = (Model as ModelDefinition<StockLocation>).extend({
  department: belongsTo('department'),
})

export const factory = Factory.extend<StockLocation>({
  name() {
    return randCity()
  },
  is_default() {
    return false
  },
  object_id() {
    return randNumber({ min: 1, max: 999999 }).toString()
  },
  active_item_list_id() {
    return randNumber({ min: 1, max: 999999 }).toString()
  },

  afterCreate(stockLocation, server) {
    if (!stockLocation.department) {
      const department = server.schema.first('department')
      stockLocation.update({ department })
    }
  },
})

export function routes(server: MockServer) {
  server.get(
    '/stock/locations',
    function (this: MirageServer, schema, request) {
      const stockLocations = schema.all('stockLocation')
      return filterable(stockLocations, request, {
        'department.id': (item, value) => item.department?.id === value,
      })
    },
  )
}

export function seeds(server: MockServer) {
  const department1 = server.create('department', {
    id: '6',
    name: 'Department USA',
    active_item_list_id: '1',
  })
  const department2 = server.create('department', {
    id: '7',
    name: 'Department UK',
    active_item_list_id: '1',
  })
  const department3 = server.create('department', {
    id: '8',
    name: 'Department US',
    active_item_list_id: '1',
  })
  const department4 = server.create('department', {
    id: '9',
    name: 'Department FI',
    active_item_list_id: '2',
  })
  server.create('stockLocation', {
    id: '1',
    department: department1,
    is_default: true,
  })
  server.create('stockLocation', { id: '2', department: department1 })
  server.create('stockLocation', { id: '3', department: department1 })
  server.create('stockLocation', {
    id: '4',
    department: department2,
    is_default: true,
  })
  server.create('stockLocation', { id: '5', department: department2 })
  server.create('stockLocation', { id: '6', department: department3 })
  server.create('stockLocation', {
    id: '7',
    department: department3,
    is_default: true,
  })
  server.create('stockLocation', { id: '8', department: department3 })
  server.create('stockLocation', {
    id: '9',
    department: department4,
    is_default: true,
  })
}
